<template>
  <el-container class="cml-container">
    <!-- 头部信息 -->
    <el-header :class="{'is-test': isTest}">
      <div class="cml-header-left">
        <img
          src="@/assets/images/sys_name_new.png"
          class="cml-header-left__logo"
        />
        <span v-if="isTest" style="font-size: 24px; color: #fff">(测试环境)</span>
      </div>
      <div class="cml-header-right">
        <div class="cml-header-left__information">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              {{ name }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button type="text" @click="logoutBtn">退出登录</el-button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-avatar shape="circle" icon="el-icon-user-solid"></el-avatar>
        </div>
        <div class="cml-header-left__triangle">
          <div class="left__triangle_link">
            <syMakeomplaints class="syMakeomplaints" :data="makeomplaintsData"></syMakeomplaints>
          </div>
          
        </div>
      </div>
    </el-header>
    <el-container class="cml-container-main">
      <!-- 侧边栏菜单 -->
      <el-aside :width="asideWidth">
        <el-menu
          :collapse="collapse"
          background-color="#0C1116"
          text-color="#939393"
          :unique-opened="true"
        >
          <template v-for="(item, index) in menus">
            <el-submenu
              v-if="item.children"
              :key="item.id"
              :index="item.id"
              :class="'menus' + '-' + index"
            >
              <template slot="title">
                <i :class="item.icon" class="iconfont title-icon"></i>
                <span :class="'menus' + '-' + index">{{ item.name }}</span>
              </template>
              <!-- 二级菜单 -->
              <template v-for="(item_children, index_2) in item.children">
                <el-submenu
                  v-if="item_children.children"
                  :key="item_children.id"
                  :index="item_children.id"
                >
                  <template slot="title">
                    <span
                      :class="'menus' + '-' + index + '-' + index_2"
                      class="askasadksakdkddlkasdksaldklsa"
                      >{{ item_children.name }}</span
                    >
                  </template>
                  <!-- 三级菜单 -->
                  <el-menu-item
                    v-for="(
                      item_children_children, index_3
                    ) in item_children.children"
                    :key="item_children_children.id"
                    :index="item_children_children.href"
                  >
                    <router-link
                      :to="item_children_children.href"
                      @click.native="selectMenus(item_children_children)"
                      :title="item_children_children.name"
                    >
                      <span
                        :class="
                          'menus' + '-' + index + '-' + index_2 + '-' + index_3
                        "
                        >{{ item_children_children.name }}</span
                      >
                    </router-link>
                  </el-menu-item>
                </el-submenu>
                <el-menu-item v-else :key="item_children.id">
                  <router-link
                    :to="item_children.href"
                    @click.native="selectMenus(item_children)"
                    :title="item_children.name"
                  >
                    <span :class="'menus' + '-' + index + '-' + index_2">{{
                      item_children.name
                    }}</span>
                  </router-link>
                </el-menu-item>
              </template>
            </el-submenu>
            <el-menu-item
              v-else-if="item.isShow !== '0'"
              :key="item.id"
              :index="item.id"
            >
              <router-link
                :to="item.href"
                @click.native="selectMenus(item)"
                :title="item.name"
              >
                <span>{{ item.name }}</span>
              </router-link>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>
      <div
        style="height: 100%"
        :class="!collapse ? 'cml-container__200w' : 'cml-container__64w'"
      >
        <!-- 快捷菜单栏 -->
        <div class="cml-menus-list">
          <div class="cml-menus-toggle" @click="menusToggle">
            <i class="el-icon-s-fold"></i>
          </div>
          <div class="cml-menus-tag">
            <div
              class="cml-menus-tag__box"
              v-for="item in headerMenusList"
              :key="item.id"
            >
              <span
                class="cml-menus-tag__text"
                :class="{ 'is-info': setDefaultClass(item) }"
              >
                <router-link :title="item.name" :to="item.href">{{ item.name }}</router-link>
                <i
                  v-show="item.href !== '/dashboard'"
                  class="el-icon-close"
                  @click="deleteMenusTab(item)"
                ></i>
              </span>
            </div>
          </div>
        </div>
        <el-main>
          <div class="cml-content-box">
            <!-- :exclude="excludePage" -->
            <keep-alive :exclude="excludePage">
              <router-view />
            </keep-alive>
          </div>
        </el-main>
      </div>
    </el-container>
  </el-container>
</template>
<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import syMakeomplaints from 'lowcodelib/components/other/sy-make-complaints';

export default {
  name: 'HomePage',
  components: {
    syMakeomplaints
  },

  data: () => ({
    collapse: false,
    asideWidth: '200px',
    menus: [],
  }),
  computed: {
    ...mapGetters({
      // taskCenterDot: 'taskCenterDot'
    }),
    // 当前打开菜单的列表
    headerMenusList() {
      return this.$store.getters.headerMenusList;
    },
    name() {
      return this.$store.getters.userSelf.user.name;
    },
    excludePage() {
      return this.$store.getters.clearPageName;
    },
    isTest() {
      return ['testcml.syounggroup', 'localhost', '10.2.1.42'].some(el => location.origin.includes(el));
    },
    // 满意度
    makeomplaintsData() {
      const baseUrl = process.env.VUE_APP_CML_PUBLISH_URL
      return {
        name: this.$store.getters.userSelf.user.name, // 登录的中文名
        system: this.$store.getters.userSelf.user.tenantId, // 一级租户名
        token: this.$store.getters.userSelf.sessionId,  // token
        sy_baseUrl: baseUrl.substring(0,baseUrl.length -1),  // 请求地址
      };
    },

  },
  beforeMount() {
    this.addTags();
    this.menus = this.treeData();
  },
  methods: {
    setDefaultClass (item) {
      const query = Object.fromEntries(new URLSearchParams(item.href.split('?')[1]));
      if (query.id && query.id !== 'undefined' && item.href.split('?')[0] === this.$route.path) {
        return query.id !== this.$route.query.id;
      } else {
        return item.href.split('?')[0] !== this.$route.path;
      }
    },
    // 关闭菜单按钮触发
    deleteMenusTab(item) {
      let nameList = item.href.split('/');
      let name = nameList[nameList.length - 1].split('?')[0];
      this.$store.dispatch('tagsView/clearPage', name);
      this.$store.dispatch('tagsView/deleteHeaderMenusList', item);
      // 获取最后一条
      const latestView = this.headerMenusList.slice(-1)[0];
      if (latestView) {
        // 如果最后一条与当前关闭的相等
        const itemName = item.href.split('/');
        const itemHref = itemName[itemName.length - 1].split('?')[0];
        const pathName = item.href.split('/');
        const pathHref = pathName[pathName.length - 1].split('?')[0];
        if (itemHref === pathHref) {
          this.$router.push(latestView.href);
        }
      } else {
        // 该条件说明是关闭的唯一一个窗口
        this.$router.push('/');
      }
    },
    // 添加tags
    addTags() {
      this.$store.dispatch('tagsView/changeHeaderMenusList', {
        name: this.$route.query.productName || this.$route.meta.title,
        href: this.$route.fullPath || this.$route.path
      });
    },
    menusToggle() {
      this.collapse = !this.collapse;
      this.asideWidth = this.collapse ? '64px' : '200px';
    },
    // 将后端返回的菜单转成tree
    treeData() {
      let data = this.$store.getters.userSelf.menusPermissions.map(item => {
        return {
          ...item,
          href: item.href ? '/' + item.href : '',
        };
      });
      let hideNavPage = [];
      let cloneData = cloneDeep(data).filter(
        item => !hideNavPage.includes(item.name) && item.isShow !== '0',
      );
      const menuData = cloneData.filter(father => {
        let branchArr = cloneData.filter(child => father.id == child.parentId);
        branchArr.length > 0 ? (father.children = branchArr) : '';
        // isShow为0，不展示menu
        if (branchArr && branchArr.length > 0)
          father.children = branchArr.filter(item => item.isShow !== '0');
        return father.parentId == 0;
      });
      return menuData;
    },
    // 菜单选中事件
    selectMenus(item) {
      this.$store.dispatch('tagsView/clearPage', '');
      this.$store.dispatch('tagsView/changeHeaderMenusList', item);
    },
    // 登出
    logoutBtn() {
      this.$store.dispatch('user/logout').then(() => {
        this.$store.dispatch('tagsView/clearMenus', '');
        this.$router.push('/login');
      });
    },
  },
};
</script>
<style>
.sy-make-complaints .el-dialog__header {
  background-color: #fff;
  border-bottom: 1px solid #ececec;
  color: #626266;
}
.syMakeomplaints .make-tucao {
  font-size: 14px;
  color: #fff;
}
.syMakeomplaints .sy-make-complaints-title svg {
  width: 20px;
  height: 20px;
}
</style>

<style lang="less">
@import '../assets/styles/index.less';
.cml-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}
.el-header {
  background: #ffffff;
  padding: 0 !important;
  border-bottom: 4px solid #AB0033;
  display: flex;
  flex-direction: row;
  .cml-header-left {
    height: 60px;
    width: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .cml-header-left__logo {
      margin-left: 35px;
    }
    .cml-header-left__title {
      font-size: 20px;
      margin-left: 10px;
    }
  }
  .cml-header-right {
    height: 60px;
    width: 50%;
    display: flex;
    flex-direction: row-reverse;
    .cml-header-left__information {
      width: auto;
      height: 60px;
      padding: 0 20px;
      line-height: 60px;
      background: #AB0033;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      .el-dropdown {
        margin-left: 10px;
        color: #ffffff;
      }
    }
    .cml-header-left__triangle {
      line-height: 60px;
      border-bottom: 60px solid #AB0033;
      border-left: 30px solid transparent;
      .left__triangle_link {
        display: flex;
        line-height: 60px;
        height: 60px;
        align-items: center;
      }
    }
  }
}
.is-test {
  background: #969696 !important;
}
.cml-container-main {
  display: flex;
  flex-direction: row;
  .cml-container__200w {
    width: calc(100% - 200px);
  }
  .cml-container__64w {
    width: calc(100% - 64px);
  }
  .el-aside {
    background: #0c1116;
    transition: width 0.5s;
  }
  .el-menu,
  .el-menu--vertical .el-menu {
    border-right: none;
    .el-submenu {
      .el-submenu__title {
        height: 40px;
        line-height: 40px;
        .title-icon {
          font-size: 22px;
          margin-right: 10px;
        }
      }
      .el-menu-item {
        line-height: 35px;
        height: 35px;
        a {
          display: block;
          line-height: 35px;
          text-decoration: none;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #939393;
          &.router-link-active,
          &:hover {
            outline: none;
            //background: #AB0033;
            color: #AB0033;
            i {
              color: #AB0033;
              font-size: 18px;
            }
          }
        }
      }
    }
  }
  .cml-menus-list {
    width: 100%;
    display: flex;
    flex-direction: row;
    .cml-menus-toggle {
      width: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 20px;
      color: #666666;
      cursor: pointer;
    }
    .cml-menus-tag {
      .cml-menus-tag__box {
        float: left;
        height: 40px;
        line-height: 40px;
        .cml-menus-tag__text {
          display: inline-block;
          height: 100%;
          position: relative;
          a {
            max-width: 150px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .el-icon-close {
            position: absolute;
            top: 8px;
            right: 8px;
            font-size: 10px;
            color: #AB0033;
            width: 15px;
            height: 15px;
            line-height: 15px;
            text-align: center;
            border: 1px solid #fff;
            border-radius: 50%;
            cursor: pointer;
          }
          .el-icon-close:hover {
            background: #AB0033;
            color: #fff !important;
          }
        }
        .cml-menus-tag__text:hover {
          background: #fafafa;
          border-bottom: 2px solid #AB0033;
          .el-icon-close {
            color: #AB0033;
          }
        }
        .is-info {
          a {
            color: #909399;
            font-size: 14px;
            border-bottom: none;
            background: none;
          }
          .el-icon-close {
            color: #909399;
          }
        }
        a {
          background: #fafafa;
          text-decoration: none;
          color: #AB0033;
          font-size: 14px;
          display: inline-block;
          height: 100%;
          padding: 0 30px;
          border-bottom: 2px solid #AB0033;
        }
      }
    }
  }
  .el-main {
    background: #eff2f5;
    padding: 10px;
    height: calc(100vh - 110px);
    .cml-content-box {
      padding: 5px;
      background: #ffffff;
      min-height: 100%;
      box-sizing: border-box;
    }
  }
}
.el-menu--vertical .el-menu {
  border-right: none;
  .el-menu-item {
    line-height: 35px;
    height: 35px;
    a {
      display: block;
      line-height: 35px;
      text-decoration: none;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #939393;
      &.router-link-active,
      &:hover {
        outline: none;
        //background: #AB0033;
        color: #AB0033;
        i {
          color: #AB0033;
          font-size: 18px;
        }
      }
    }
  }
  .el-submenu {
    .el-submenu__title {
      height: 40px;
      line-height: 40px;
    }
    .el-menu-item {
      line-height: 35px;
      height: 35px;
      a {
        display: block;
        line-height: 35px;
        text-decoration: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #939393;
        &.router-link-active,
        &:hover {
          outline: none;
          //background: #AB0033;
          color: #AB0033;
          i {
            color: #AB0033;
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>
